import { Input, Table } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { UserDcom } from "../../../../Data/data_user";
import { MyModal } from "../../../../components/styled-components";
import { GET } from "../../../../services";
import { CHECHKER_GET_USER_DCOM } from "../../../../services/path";

interface UserModalProps {
  visible: boolean;
  onCancel: () => void;
  onSelectUser: (user: UserDcom | null) => void;
}

const ModalUserDcom: React.FC<UserModalProps> = ({ visible, onCancel, onSelectUser }) => {
  const [data, setData] = useState<UserDcom[]>([]);
  const [filteredData, setFilteredData] = useState(data);
  const [searchValue, setSearchValue] = useState(""); // Track search value
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // Initial page size
  const tableRef = useRef<HTMLDivElement | null>(null);
  const handleRowDoubleClick = (record: UserDcom) => {
    if (record) {
      onSelectUser(record);
      onCancel(); // Close the modal
    }
  };

  const handlePageSizeChange = (size: number) => {
    setPageSize(size);
    setCurrentPage(1); // Reset to the first page when changing page size
  };

  const fetchData = async () => {
    try {
      const result = await GET(CHECHKER_GET_USER_DCOM);
      setData(result);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(); // Fetch data when the component mounts
  }, []); // Empty dependency array means this effect will only run once (when the component mounts)

  const handleSearch = (value: string) => {
    setSearchValue(value.trim()); // Track the search value and trim leading/trailing whitespace
  };

  useEffect(() => {
    if (searchValue === "") {
      setFilteredData(data);
    } else {
      const filteredList = data.filter((item) => {
        return Object.values(item).some(
          (value) => value && value.toString().toLowerCase().includes(searchValue.toLowerCase()),
        );
      });

      setFilteredData(filteredList);
    }
  }, [searchValue, data]);

  useEffect(() => {
    if (tableRef.current) {
      const table = tableRef.current;
      const isOverflowing = table.scrollWidth > table.clientWidth;
      table.style.overflowX = isOverflowing ? "scroll" : "auto";
    }
  }, [data]);

  const columns = [
    {
      title: <div style={{ textAlign: "center" }}>User ID</div>,
      dataIndex: "user_id",
      key: "user_id",
      render: (text: string) => (
        <div style={{ textAlign: "center" }}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: <div style={{ textAlign: "center" }}>Username</div>,
      dataIndex: "username",
      key: "username",
      render: (text: string) => (
        <div style={{ textAlign: "center" }}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: <div style={{ textAlign: "center" }}>ชื่อจริง</div>,
      dataIndex: "firstname",
      key: "firstname",
      render: (text: string) => (
        <div style={{ textAlign: "center" }}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: <div style={{ textAlign: "center" }}>นามสกุล</div>,
      dataIndex: "lastname",
      key: "lastname",
      render: (text: string) => (
        <div style={{ textAlign: "center" }}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: <div style={{ textAlign: "center" }}>ชื่อเล่น</div>,
      dataIndex: "nickname",
      key: "nickname",
      render: (text: string) => (
        <div style={{ textAlign: "center" }}>
          <span>{text}</span>
        </div>
      ),
    },
  ];

  return (
    <MyModal
      visible={visible}
      title="พนักงานทั้งหมด"
      onCancel={onCancel}
      width={"70vw"}
      footer={null}
    >
      <div style={{ marginBottom: "10px", width: "20vw" }}>
        <Input.Search
          placeholder="------- กรุณาใส่ช้อมูลเพื่อค้นหา -------"
          onSearch={handleSearch}
          value={searchValue} // Set the value of the search input
          onChange={(e) => setSearchValue(e.target.value)} // Update searchValue on input change
        />
      </div>
      <div ref={tableRef}>
        <Table
          columns={columns}
          dataSource={filteredData}
          pagination={{
            position: ["bottomRight"],
            pageSize: pageSize,
            showSizeChanger: false,
            onShowSizeChange: (_, size) => handlePageSizeChange(size),
            current: currentPage,
            onChange: (page) => setCurrentPage(page),
          }}
          onRow={(record) => ({
            onDoubleClick: () => handleRowDoubleClick(record),
          })}
        />
      </div>
    </MyModal>
  );
};

export default ModalUserDcom;
